import { addLoader, apiSlice, asyncToastDisplay, i18n } from "./apiSlice";

export const abRemoteStrategyApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getAbRemoteStrategy: builder.query({
      query: (appId) => {
        return {
          url: `/apps/${appId}/ab_remote_strategy`
        }},
      providesTags: (result = [], error, arg) => [{ type: 'AbRemoteStrategies', id: arg } ],
      onQueryStarted: addLoader(),
    }),
    updateAbRemoteStrategy: builder.mutation({
      query: (data) => ({
        url: `/apps/${data.app_id}/ab_remote_strategy`,
        method: 'PUT',
        body: data,
      }),
      onQueryStarted: asyncToastDisplay({successMessage: i18n.t("toast.updated")}),
      invalidatesTags: (result, error, arg) => {
        return [{ type: 'AbRemoteStrategies', id: arg.app_id }]
      }
    }),
    deleteAbRemoteStrategy: builder.mutation({
      query: (app_id) => ({
        url: `/apps/${app_id}/ab_remote_strategy`,
        method: 'DELETE',
        body: app_id,
      }),
      onQueryStarted: asyncToastDisplay({successMessage: i18n.t("toast.deleted")}),
      invalidatesTags: (result, error, arg) => [{ type: 'AbRemoteStrategies', id: arg }]
    }),
  }),
  overrideExisting: false
})

export const {
  useGetAbRemoteStrategyQuery,
  useUpdateAbRemoteStrategyMutation,
  useDeleteAbRemoteStrategyMutation
} = abRemoteStrategyApiSlice
